import { compareDesc, toDate } from 'date-fns'

export const compareInstantDesc = (instant1: Instant, instant2: Instant) =>
  compareDesc(toDate(instant1), toDate(instant2))
